module.exports = __webpack_public_path__ + "static/media/zhengwu.fe63456b.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/pageCommercialPassword/zhengwu.png
// module id = 611
// module chunks = 0